import React from 'react'
import DefaultLayout from '../../components/DefaultLayout'
import Footer from '../../components/Footer/Footer'
import SubPageHeader from '../../components/SubPageHeader'
import ContentArea from '../../components/ContentArea'
import { Link as HeadLink, Title } from 'react-head'
import PrivacyPolicyDE from '../../components/privacy-policy/PrivacyPolicyDE'

const PolicyPageDE = () => {
  return (
    <DefaultLayout>
      <Title>AGB & Datenschutz - Lifesum</Title>
      <HeadLink rel="canonical" href="https://lifesum.com/policy/" />
      <HeadLink
        rel="alternate"
        href={`https://lifesum.com/policy-de/`}
        // @ts-ignore
        hreflang="de"
      />
      <SubPageHeader heading="AGB & Datenschutz" language={false} />
      <ContentArea>
        <div className="s-text">
          <PrivacyPolicyDE language="de" />
        </div>
      </ContentArea>
      <Footer />
    </DefaultLayout>
  )
}

export default PolicyPageDE
